import { useTranslation } from "react-i18next";
import { Text } from "@/components/ui/Text";
import type { SubjectSaveStatusProps } from "@/types/creative-library";
export function SubjectSaveStatus({ dirty }: SubjectSaveStatusProps) {
  const { t } = useTranslation("app");
  return (
    <Text
      size="xs"
      color="muted"
      role="status"
      className="mr-auto self-center"
      data-testid="subject-save-status"
    >
      {t(
        dirty
          ? "creativeLibrary.identityUnsaved"
          : "creativeLibrary.identitySaved",
      )}
    </Text>
  );
}
